import { render, staticRenderFns } from "./ktxc-SUBJECTIVE.vue?vue&type=template&id=63ca1286&scoped=true"
import script from "./ktxc-SUBJECTIVE.vue?vue&type=script&lang=js"
export * from "./ktxc-SUBJECTIVE.vue?vue&type=script&lang=js"
import style0 from "./ktxc-SUBJECTIVE.vue?vue&type=style&index=0&id=63ca1286&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca1286",
  null
  
)

export default component.exports